import { asList2ho2pewtsfvv as asList } from '../../../../kotlin-kotlin-stdlib/kotlin/collections/_ArraysJs.mjs';
import {
  charSequenceLength3278n89t01tmv as charSequenceLength,
  charSequenceGet1vxk1y5n17t1z as charSequenceGet,
  charCodeAt1yspne1d8erbm as charCodeAt,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/charSequenceJs.mjs';
import {
  _Char___init__impl__6a9atx1csff5kwtduxl as _Char___init__impl__6a9atx,
  Char__compareTo_impl_ypi4mb3frsmupst9pih as Char__compareTo_impl_ypi4mb,
  toString3dhdjl9yf50de as toString,
  Char__toInt_impl_vasixd3jl92hthlhyn7 as Char__toInt_impl_vasixd,
} from '../../../../kotlin-kotlin-stdlib/kotlin/Char.mjs';
import { Unit_instance28fytmsmm6r23 as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import {
  initMetadataForObject1cxne3s9w65el as initMetadataForObject,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { IllegalArgumentException2asla15b5jaob as IllegalArgumentException } from '../../../../kotlin-kotlin-stdlib/kotlin/exceptions.mjs';
import { captureStack1fzi4aczwc4hg as captureStack } from '../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { contains2el4s70rdq4ld as contains } from '../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var HttpHeadersClass;
function HttpHeaders() {
  if (HttpHeadersClass === VOID) {
    class $ {
      constructor() {
        HttpHeaders_instance = this;
        this.q4v_1 = 'Accept';
        this.r4v_1 = 'Accept-Charset';
        this.s4v_1 = 'Accept-Encoding';
        this.t4v_1 = 'Accept-Language';
        this.u4v_1 = 'Accept-Ranges';
        this.v4v_1 = 'Age';
        this.w4v_1 = 'Allow';
        this.x4v_1 = 'ALPN';
        this.y4v_1 = 'Authentication-Info';
        this.z4v_1 = 'Authorization';
        this.a4w_1 = 'Cache-Control';
        this.b4w_1 = 'Connection';
        this.c4w_1 = 'Content-Disposition';
        this.d4w_1 = 'Content-Encoding';
        this.e4w_1 = 'Content-Language';
        this.f4w_1 = 'Content-Length';
        this.g4w_1 = 'Content-Location';
        this.h4w_1 = 'Content-Range';
        this.i4w_1 = 'Content-Type';
        this.j4w_1 = 'Cookie';
        this.k4w_1 = 'DASL';
        this.l4w_1 = 'Date';
        this.m4w_1 = 'DAV';
        this.n4w_1 = 'Depth';
        this.o4w_1 = 'Destination';
        this.p4w_1 = 'ETag';
        this.q4w_1 = 'Expect';
        this.r4w_1 = 'Expires';
        this.s4w_1 = 'From';
        this.t4w_1 = 'Forwarded';
        this.u4w_1 = 'Host';
        this.v4w_1 = 'HTTP2-Settings';
        this.w4w_1 = 'If';
        this.x4w_1 = 'If-Match';
        this.y4w_1 = 'If-Modified-Since';
        this.z4w_1 = 'If-None-Match';
        this.a4x_1 = 'If-Range';
        this.b4x_1 = 'If-Schedule-Tag-Match';
        this.c4x_1 = 'If-Unmodified-Since';
        this.d4x_1 = 'Last-Modified';
        this.e4x_1 = 'Location';
        this.f4x_1 = 'Lock-Token';
        this.g4x_1 = 'Link';
        this.h4x_1 = 'Max-Forwards';
        this.i4x_1 = 'MIME-Version';
        this.j4x_1 = 'Ordering-Type';
        this.k4x_1 = 'Origin';
        this.l4x_1 = 'Overwrite';
        this.m4x_1 = 'Position';
        this.n4x_1 = 'Pragma';
        this.o4x_1 = 'Prefer';
        this.p4x_1 = 'Preference-Applied';
        this.q4x_1 = 'Proxy-Authenticate';
        this.r4x_1 = 'Proxy-Authentication-Info';
        this.s4x_1 = 'Proxy-Authorization';
        this.t4x_1 = 'Public-Key-Pins';
        this.u4x_1 = 'Public-Key-Pins-Report-Only';
        this.v4x_1 = 'Range';
        this.w4x_1 = 'Referer';
        this.x4x_1 = 'Retry-After';
        this.y4x_1 = 'Schedule-Reply';
        this.z4x_1 = 'Schedule-Tag';
        this.a4y_1 = 'Sec-WebSocket-Accept';
        this.b4y_1 = 'Sec-WebSocket-Extensions';
        this.c4y_1 = 'Sec-WebSocket-Key';
        this.d4y_1 = 'Sec-WebSocket-Protocol';
        this.e4y_1 = 'Sec-WebSocket-Version';
        this.f4y_1 = 'Server';
        this.g4y_1 = 'Set-Cookie';
        this.h4y_1 = 'SLUG';
        this.i4y_1 = 'Strict-Transport-Security';
        this.j4y_1 = 'TE';
        this.k4y_1 = 'Timeout';
        this.l4y_1 = 'Trailer';
        this.m4y_1 = 'Transfer-Encoding';
        this.n4y_1 = 'Upgrade';
        this.o4y_1 = 'User-Agent';
        this.p4y_1 = 'Vary';
        this.q4y_1 = 'Via';
        this.r4y_1 = 'Warning';
        this.s4y_1 = 'WWW-Authenticate';
        this.t4y_1 = 'Access-Control-Allow-Origin';
        this.u4y_1 = 'Access-Control-Allow-Methods';
        this.v4y_1 = 'Access-Control-Allow-Credentials';
        this.w4y_1 = 'Access-Control-Allow-Headers';
        this.x4y_1 = 'Access-Control-Request-Method';
        this.y4y_1 = 'Access-Control-Request-Headers';
        this.z4y_1 = 'Access-Control-Expose-Headers';
        this.a4z_1 = 'Access-Control-Max-Age';
        this.b4z_1 = 'X-Http-Method-Override';
        this.c4z_1 = 'X-Forwarded-Host';
        this.d4z_1 = 'X-Forwarded-Server';
        this.e4z_1 = 'X-Forwarded-Proto';
        this.f4z_1 = 'X-Forwarded-For';
        this.g4z_1 = 'X-Forwarded-Port';
        this.h4z_1 = 'X-Request-ID';
        this.i4z_1 = 'X-Correlation-ID';
        this.j4z_1 = 'X-Total-Count';
        this.k4z_1 = 'Last-Event-ID';
        var tmp = this;
        // Inline function 'kotlin.arrayOf' call
        // Inline function 'kotlin.js.unsafeCast' call
        // Inline function 'kotlin.js.asDynamic' call
        tmp.l4z_1 = ['Transfer-Encoding', 'Upgrade'];
        this.m4z_1 = asList(this.l4z_1);
      }
      n4z(name) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(name)) {
          var item = charSequenceGet(name, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) <= 0 || isDelimiter(item)) {
            throw IllegalHeaderNameException().y4z(name, _unary__edvuaz);
          }
        }
      }
      o4z(value) {
        // Inline function 'kotlin.text.forEachIndexed' call
        var index = 0;
        var inductionVariable = 0;
        while (inductionVariable < charSequenceLength(value)) {
          var item = charSequenceGet(value, inductionVariable);
          inductionVariable = inductionVariable + 1 | 0;
          var _unary__edvuaz = index;
          index = _unary__edvuaz + 1 | 0;
          if (Char__compareTo_impl_ypi4mb(item, _Char___init__impl__6a9atx(32)) < 0 && !(item === _Char___init__impl__6a9atx(9))) {
            throw IllegalHeaderValueException().f50(value, _unary__edvuaz);
          }
        }
      }
    }
    initMetadataForObject($, 'HttpHeaders');
    HttpHeadersClass = $;
  }
  return HttpHeadersClass;
}
var HttpHeaders_instance;
function HttpHeaders_getInstance() {
  if (HttpHeaders_instance === VOID)
    new (HttpHeaders())();
  return HttpHeaders_instance;
}
var UnsafeHeaderExceptionClass;
function UnsafeHeaderException() {
  if (UnsafeHeaderExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static k50(header) {
        var $this = this.s2('Header(s) ' + header + ' are controlled by the engine and ' + 'cannot be set explicitly');
        captureStack($this, $this.j50_1);
        return $this;
      }
    }
    initMetadataForClass($, 'UnsafeHeaderException');
    UnsafeHeaderExceptionClass = $;
  }
  return UnsafeHeaderExceptionClass;
}
function isDelimiter(ch) {
  return contains('"(),/:;<=>?@[\\]{}', ch);
}
var IllegalHeaderNameExceptionClass;
function IllegalHeaderNameException() {
  if (IllegalHeaderNameExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static y4z(headerName, position) {
        var tmp = "Header name '" + headerName + "' contains illegal character '" + toString(charCodeAt(headerName, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerName, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.s2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.x4z_1);
        $this.v4z_1 = headerName;
        $this.w4z_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderNameException');
    IllegalHeaderNameExceptionClass = $;
  }
  return IllegalHeaderNameExceptionClass;
}
var IllegalHeaderValueExceptionClass;
function IllegalHeaderValueException() {
  if (IllegalHeaderValueExceptionClass === VOID) {
    class $ extends IllegalArgumentException() {
      static f50(headerValue, position) {
        var tmp = "Header value '" + headerValue + "' contains illegal character '" + toString(charCodeAt(headerValue, position)) + "'";
        // Inline function 'kotlin.code' call
        var this_0 = charCodeAt(headerValue, position);
        var tmp$ret$0 = Char__toInt_impl_vasixd(this_0);
        var $this = this.s2(tmp + (' (code ' + (tmp$ret$0 & 255) + ')'));
        captureStack($this, $this.e50_1);
        $this.c50_1 = headerValue;
        $this.d50_1 = position;
        return $this;
      }
    }
    initMetadataForClass($, 'IllegalHeaderValueException');
    IllegalHeaderValueExceptionClass = $;
  }
  return IllegalHeaderValueExceptionClass;
}
//region block: exports
export {
  HttpHeaders_getInstance as HttpHeaders_getInstance1z5nmwg0t7mku,
  UnsafeHeaderException as UnsafeHeaderException3ncvrrp48xjzq,
};
//endregion

//# sourceMappingURL=HttpHeaders.mjs.map
